module.exports = __webpack_public_path__ + "img/neirongjingying.d99f7a07.png";